module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAKCAYAAACALL/6AAAAAXNSR0IArs4c6QAAAUtJREFUKFNdUD1LA0EQfbO7FoohpDxS+DMsUtikEqvgFVrmyCQcVhYiQbhC/AE257KrBpSAWNupkN4uSMBCCAgXsEuKswm3coFIvKnm470384ZQiCiK1GQyOXHODa21T8U5rTZ831+vVCoGgAeg6px7TtP0rN/vz5a4P0IYhpvz+fwRwMzzvEMAIkmSGyLaFkLsa63fc9KC0Gw2S1LKFyJ6M8YcrW5ttVp7AO6JqOt5nqUcrJQaArg1xpzn4E6nU82yrGSM+QDgmHkDwADAmJj5zjk3sNb28mEQBDUp5SuAFMCDMSbMRaIoEqPRSP0zzcw+gCvn3E65XB5Pp9OYiGpCiLrWevznIU+YuQ3gFEDdGPO5VE2SJPdwDeDCWnu52MDMXQAHSqndOI6/ir8PgmBLStlzzv1Qu91uZFl2LKVsaK2/i+Blzcxr+am/TLSAxPIpgUcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_shouqii_nor.png
// module id = 9R12
// module chunks = 1